import { render } from "./QrcodeNavShell.vue?vue&type=template&id=2873d574&scoped=true"
import script from "./QrcodeNavShell.vue?vue&type=script&lang=js"
export * from "./QrcodeNavShell.vue?vue&type=script&lang=js"

import "./QrcodeNavShell.vue?vue&type=style&index=0&id=2873d574&scoped=true&lang=less"

import exportComponent from "D:\\work\\sckj\\tipian\\vue\\tipian_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2873d574"]])

export default __exports__